import React, { useEffect, useRef, useState } from 'react';
import './element-view.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import PlayerEarningsList from './player-earnings-list.component';
import { getGameElementsFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified';

const ElementView = ({
  gameData,
  gameElements,
  playerData,
  indActivityData,
  isSecretCode
}) => {

  const { elementPath } = useParams();
  const [elementData, setElementData] = useState(null);
  const [activity, setActivity] = useState(null);
  const navigate = useNavigate();
  const activityRef = useRef();
  const location = useLocation();

  useEffect(() => {
    if (!playerData || !elementPath || !gameElements) return;
    console.log(indActivityData)
    if (indActivityData) {
      setElementData({
        'icon': indActivityData.icon,
        'name': indActivityData.event,
        'elementId': indActivityData.elementId
      })
    } else {
      getElementData();
    }
  }, [playerData, elementPath, gameElements, indActivityData])

  useEffect(() => {
    if (!completeGameElementData || !elementPath) return;
    getElementData();
    console.log(completeGameElementData);
  }, [completeGameElementData, elementPath])

  function getElementData() {
    if (location.pathname.includes('/preview/manager/')) {
      setElementData(
        Object.values(completeGameElementData)
          .find(e => isSecretCode 
            ? e.id === elementPath
            : e.path === elementPath
          )
      );
      return;
    }
    if (isSecretCode) {
      getUniqueDocumentFromFirestore({
        'path': `games/${gameData.gameId}/gameElements/${elementPath}`,
        'once': true,
        'callback': callback
      })
    } else {
      getGameElementsFromDb({
        'gameId': gameData.gameId,
        'path': elementPath,
        'once': true,
        'callback': callback
      })
    }

    function callback(data) {
      console.log(data);
      setElementData(
        isSecretCode
        ? data
        : Object.values(data)[0]
      );
    }
  }

  return (
    <div className='element-view'>
      <div className='g-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        {
          (elementData && gameData)
            ?
            <div>
              <div className='element-view-header'>
                <ImageContainer
                  src={elementData.icon}
                  className='icon'
                  alt={`${elementData.name}'s icon`}
                />
                <div>
                  <div className='card-title'>{elementData.name}</div>
                  <div className="g-space-1"></div>
                  {elementData.opt_cat && <div className='info'><b>Category:</b> {elementData.opt_cat}</div>}
                </div>
              </div>
              {
                (elementData.desc) &&
                <>
                  <div className="g-space-1"></div>
                  <div dangerouslySetInnerHTML={{ __html: elementData.desc }}>
                  </div>
                </>
              }
              <hr />
              <PlayerEarningsList
                gameData={gameData}
                playerData={playerData}
                gameElements={gameElements}
                type={elementData.id}
              />
              {/* {
                            (activity && activity.length > 0) &&
                            <>
                            <hr />
                            <h3>Earning Record</h3>
                            <div className='earning-list'>
                                {
                                    activity.map(a => (
                                        <div key={a.ts} className='g-list-item'>
                                            <div className='icon'>
                                                <ImageContainer src={a.icon} />
                                            </div>
                                            <div className='info'>
                                                <h4>{a.activity}: {a.title}</h4>
                                                <p>
                                                {
                                                    (a.event === 'Secret Code Found') &&
                                                    <div>
                                                        <b>{a.info}</b>
                                                    </div>
                                                }
                                                Earned {format(new Date(a.ts), 'P')}
                                                {
                                                    (a.info) && 
                                                    <div>
                                                        Details: <br /><b>"{a.comments}"</b>
                                                    </div>
                                                }
                                                {
                                                    (a.comments) && 
                                                    <div>
                                                        Evaluator comments:<br /><b>"{a.comments}"</b>
                                                    </div>
                                                }
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            </>
                        } */}

            </div>
            :
            <div className='center-col'><ThreeDotsLoader /></div>
        }
      </div>
    </div>
  )
}

export default ElementView